import React from "react";
import AllApprovers from "./ApproversModule/AllApprovers";

const Approvers = () => {
  return (
    <div>
      <AllApprovers />
    </div>
  );
};

export default Approvers;
